import { Injectable, inject } from '@angular/core';

import { FetchPolicy } from '@apollo/client/core';
import { Observable, catchError, map, mergeMap, of } from 'rxjs';

import { CamTenantService } from '@camelot/server';
import { CamLazyTranslationService } from '@camelot/translation';
import { CamUsersService } from '@camelot/user';

import { DynamicTranslation } from './dto/dynamic-translation';
import { GET_DYNAMIC_TRANSLATION } from './queries';

export const dynamicTranslationPrefix = (denomination: string) => `dynamictranslation.${denomination}`;

@Injectable({
  providedIn: 'root',
})
export class CamDynamicTranslationService extends CamLazyTranslationService {
  private readonly _tenantService = inject(CamTenantService);
  private readonly _userService = inject(CamUsersService);

  constructor() {
    super('dynamictranslation', false);
  }

  public override getTranslation(lang: string, fetchPolicy?: FetchPolicy): Observable<object | null> {
    return this._userService.fetchCurrentUser$().pipe(
      catchError(() => of(null)),
      mergeMap(user =>
        !user
          ? of(null)
          : this._strapiService
              .fetchQueryList$<DynamicTranslation>(
                GET_DYNAMIC_TRANSLATION(lang, this._tenantService.currentTenantId() ?? 0),
                'translationsDynamictranslations',
                fetchPolicy
              )
              .pipe(map(translations => this._toTranslationTree(translations)))
      )
    );
  }
}
